<template>
    <a :href="prefix + '/'" class="logo__link">
        <img v-if="render" class="logo__img" :src="partnerLogo">

        <div v-if="render" class="logo__separator"></div>

        <picture class="logo__img">
            <source media="(min-width: 768px)" :srcset="path + logo">

            <img class="logo__img--icon" :src="path + mobileLogo" :alt="$lang('app.memory_code')">
        </picture>
    </a>
</template>

<script>
export default {
    name: 'HeaderLogo',
    props: {
        render: {
            default: false
        },
        partnerLogo: {
            default: null
        }
    },
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix
        }
    },
    computed: {
        path() {
            return this.domain + '/assets/front/img';
        },
        logo() {
            let path = null;

            switch(window.laravel.locale) {
                case 'ru':
                    path = '/logo_ru.svg';
                    break;
                default:
                    path = '/logo_en.svg';
            }

            return path;
        },
        mobileLogo() {
            let path = null;

            switch(window.laravel.locale) {
                case 'ru':
                    path = '/logo_mobile_ru.svg';
                    break;
                default:
                    path = '/logo_mobile_en.svg';
            }

            return path;
        }
    }
}
</script>
